import { render } from "./ParticlesBackgroundView.vue?vue&type=template&id=13288bab&scoped=true"
const script = {}

import "./ParticlesBackgroundView.vue?vue&type=style&index=0&id=13288bab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13288bab"]])

export default __exports__